import {
  INSTITUTE_LEGAL_STATUS_CHOICES,
  BASIC_SERVICE_CHOICES,
  SDGs,
  WORLD_REGION_CHOICES
} from "utils/choices.jsx";

const schema = {
  title: "",
  description: "",
  type: "object",
  properties: {
    legal_status: {
      type: "string",
      title: "Legal Status ",
      options: INSTITUTE_LEGAL_STATUS_CHOICES["Academia"]
    },
    research_areas: {
      type: "string",
      title: "Research Areas ",
      options: BASIC_SERVICE_CHOICES,
      required: false
    },
    sustainable_development_goals: {
      type: "string",
      title: "Sustainable Development Goals",
      options: SDGs
    },
    region: {
      type: "string",
      title: "Region",
      options: WORLD_REGION_CHOICES
    }
  }
};

const uiSchema = [
  {
    container: "griditem",
    items: {
      region: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      },
      sustainable_development_goals: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  },
  {
    container: "griditem",
    items: {
      legal_status: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      },
      research_areas: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  }
];

export const AcademiaFormSchema = {
  schema: schema,
  uiSchema: uiSchema
};
